import React, { Fragment } from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { ResourceFeatures, ServiceFeatures } from "../../common/const";
import { Check, Hexagon } from "@mui/icons-material";
import theme from "../../theme";
import CommonCard from "../../common/components/CommonCard";

export const FeatureHex = ({
    feature,
    containerSx = {},
    contentTop = '50%',
}) => {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex', ...containerSx }}>
            <Hexagon sx={{ color: feature.color, fontSize: 470 }} />
            <Box
                sx={{
                    position: 'absolute',
                    top: contentTop,
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                }}
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={1}
                flexDirection="column"
            >
                <Box display="flex" gap={1} alignItems="center">
                    <Box>
                        {feature.images}
                    </Box>
                    <Typography
                        color={theme.palette.secondary.main}
                        fontWeight={600}
                        fontSize={18}
                    >
                        {feature.title}
                    </Typography>
                </Box>
                <Typography textAlign="center">
                    {feature.subTitle}
                </Typography>
            </Box>
        </Box>
    );
};

const layout = [
    [
        { index: 0, sx: { mr: -2, ml: -5 }, top: '50%' },
        { index: 1, sx: { ml: -17, mt: -22.5 }, top: '35%' },
        { index: 2, sx: { ml: -19 }, top: '50%' },
        { index: 3, sx: { ml: -19, mt: -22.5 }, top: '35%' },
    ],
    [
        { index: 4, sx: { ml: 34.5, mt: -27.5 }, top: '50%' },
        { index: 5, sx: { ml: 21, mt: -27.5 }, top: '50%' },
    ]
];

const Feature = ({
    isServices
}) => {
    return (
        <Box
            sx={{
                height: isServices ? '120vh' : '100vh',
                width: '100%',
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 1,
                    backgroundImage: `url('/Images/servicebackground12.png')`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                }}
            />
            <Box
                sx={{
                    position: 'relative',
                    zIndex: 3,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    p: 3,
                    maxWidth: '1400px',
                    mx: 'auto',
                }}
            >
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Box width='50%'>
                        <Box
                            display="flex"
                            gap={1.5}
                            mb={1.6}
                        >
                            <Box sx={{ background: '#306FE8', width: '4.5%', borderRadius: 0.6 }}></Box>
                            <Typography color="White" fontSize={17} fontWeight={600}>{isServices ? 'Our Complete Suite' : 'My DCP Resources'}</Typography>
                        </Box>
                        <Typography fontSize={38} color="White" fontWeight={600} sx={{ lineHeight: 1.1 }}>
                            {isServices ? 'All-in-One Services to Plan and Build Your College Future' : 'Direct Access to our DCP Experts for Your College Journey'}
                        </Typography>
                    </Box>
                    <Box width='28%'>
                        <Typography color="White" fontSize={16} fontWeight={600}>
                            {isServices ? 'From planning and analysis to expert guidance and skill-building, DCP services are designed to support students at every stage of their college journey.'
                                : 'Work one-on-one with trusted experts to strengthen every part of your college application.'}
                        </Typography>
                    </Box>
                </Box>
                {isServices ? (
                    <Box sx={{ m: '50px auto' }}>
                        {layout.map((row, rowIndex) => (
                            <Box
                                key={rowIndex}
                                display="flex"
                                mt={rowIndex === 0 ? 12 : rowIndex === 1 ? -8 : -7}
                            >
                                {row.map(({ index, sx, top }) => (
                                    <FeatureHex
                                        key={index}
                                        feature={ServiceFeatures[index]}
                                        containerSx={sx}
                                        contentTop={top}
                                    />
                                ))}
                            </Box>
                        ))}
                    </Box>
                ) : (
                    <Grid container spacing={2} mt={2}>
                        {ResourceFeatures.map((a, index) => (
                            <Grid item md={6} key={index}>
                                <CommonCard
                                    marginTop="0px"
                                    borderRadius={1}
                                    background={a.color}
                                    content={
                                        <Fragment>
                                            <Box mb={1} display="flex" gap={1} alignItems='center'>
                                                <Box>
                                                    {a.images}
                                                </Box>
                                                <Typography
                                                    color={theme.palette.secondary.main}
                                                    fontWeight={600}
                                                    fontSize={18}
                                                >
                                                    {a.title}
                                                </Typography>
                                            </Box>
                                            <Typography fontSize={15}>{a.subTitle}</Typography>
                                            <Box mt={1} mb={1}>
                                                {a.data.map((i, innerIndex) => (
                                                    <Box display="flex" alignItems="center" gap={1} key={innerIndex} mt={1}>
                                                        <Box sx={{ background: theme.palette.secondary.main, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0.3 }}>
                                                            <Check sx={{ color: 'white', fontSize: 12 }} />
                                                        </Box>
                                                        <Typography fontSize={14} color={[1, 2].includes(index) ? theme.palette.background.dark : 'black'}>{i.title}</Typography>
                                                    </Box>
                                                ))}
                                            </Box>
                                            <Divider />
                                            <Typography fontSize={15} mt={1} color={[1, 2].includes(index) ? theme.palette.background.dark : 'black'}>{a.footerDescription}</Typography>
                                        </Fragment>
                                    }
                                />
                            </Grid>
                        ))}
                    </Grid>
                )}
            </Box>
        </Box>
    )
}

export default Feature;

